import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FormControl from 'react-bootstrap/lib/FormControl';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import { connect } from 'react-redux';
import { validateEmail, setEmailInputToWarning } from 'redux/modules/auth';

@connect(
  (state) => ({
    emailValid: state.auth.emailValid,
    emailValidationError: state.auth.emailValidationError,
    emailValidationWarningClass: state.auth.emailValidationWarningClass,
    emailError: state.auth.emailError,
  }),
  { validateEmail, setEmailInputToWarning }
)
class EmailInput extends Component {
  static propTypes = {
    type: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.string,
    emailValidationError: PropTypes.string,
    emailValid: PropTypes.bool,
    placeholder: PropTypes.string,
    validateEmail: PropTypes.func,
    setEmailInputToWarning: PropTypes.func,
    emailValidationWarningClass: PropTypes.string,
    resetContinue: PropTypes.func,
    emailError: PropTypes.array,
    isInPost: PropTypes.bool,
    styles: PropTypes.object,
  };

  static defaultProps = {
    emailValid: false,
    emailValidationError: 'THIS IS THE SENDGRID ERROR',
  };

  constructor(props) {
    super(props);
  }

  validateEmailOnBlur = (e) => {
    if (
      e.target.value !== '' &&
      e.target.value.includes('@') &&
      e.target.value.includes('.')
    ) {
      this.props.validateEmail(e.target.value);
    }
    this.props.resetContinue();
    this.props.setEmailInputToWarning();
  };

  render() {
    const {
      type,
      placeholder,
      value,
      onChange,
      disabled,
      emailError,
      emailValid,
      emailValidationError,
      emailValidationWarningClass,
      styles,
    } = this.props;

    const inputClassName =
      emailValidationWarningClass === 'emailDanger'
        ? 'emailInputDanger'
        : 'input';

    const shouldDisplayError = !emailValid && emailError.length === 0;

    return (
      <div>
        <FormControl
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={this.validateEmailOnBlur}
          disabled={disabled}
          className={styles[inputClassName]}
        />
        {shouldDisplayError && (
          <HelpBlock className={styles[emailValidationWarningClass]}>
            {emailValidationError}
          </HelpBlock>
        )}
      </div>
    );
  }
}

export default EmailInput;
